module.exports = __webpack_public_path__ + "img/ev_styles.adcd0ae6.png";